import { useState, useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ContractorsFilters from './components/ContractorsFilters'
import ContractorDashboard from './components/ContractorDashboard'

const ContractorsPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [filters, setFilters] = useState<{
    year?: number
    cpvCode: string
    contractorName: string
  }>(() => {
    const yearParam = searchParams.get('year')
    return {
      year: yearParam ? parseInt(yearParam) : undefined,
      cpvCode: searchParams.get('cpv_code') || '',
      contractorName: searchParams.get('contractor_name') || '',
    }
  })

  const handleFiltersChange = useCallback(
    (newFilters: { year?: number; cpvCode: string; contractorName: string }) => {
      setFilters(newFilters)
    },
    [],
  )

  const handleContractorClick = (contractorUuid: string) => {
    // Navigate to drilldown page with contractor UUID in URL
    navigate(
      `/contractors/${contractorUuid}${searchParams.toString() ? '?' + searchParams.toString() : ''}`,
    )
  }

  const handleRefresh = () => {
    // Trigger refresh of statistics
    window.location.reload()
  }

  return (
    <div className="space-y-6">
      <div className="bg-surface-raised rounded-lg border border-border-subtle p-6">
        <h1 className="text-2xl font-bold text-ink mb-2">Wykonawcy</h1>
        <p className="text-ink-secondary">
          Analiza wykonawców publicznych - ranking wykonawców wg wartości i liczby wygranych
          postępowań
        </p>
      </div>

      <ContractorsFilters onFiltersChange={handleFiltersChange} />

      <ContractorDashboard
        year={filters.year}
        cpvCode={filters.cpvCode}
        contractorName={filters.contractorName}
        onContractorClick={handleContractorClick}
        onRefresh={handleRefresh}
      />
    </div>
  )
}

export default ContractorsPage
